// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"772":"MobileChunk","976":"DesktopChunk"}[chunkId] || chunkId) + "." + {"33":"5fd47e55f583f213329e","772":"44cc51d22635b33f0370","773":"b4358c688545c636852f","976":"bdd9c72cafb187742db9"}[chunkId] + ".css";
};